import { Controller } from "@hotwired/stimulus"
import { CountUp } from 'countup.js';

// Connects to data-controller="count-up"
export default class extends Controller {
  static values = {
    targetId: String,
    targetNumber: Number,
    useGrouping: { type: Boolean, default: true },
    suffix: { type: String, default: '' },
    decimalPlaces: { type: Number, default: 0 }
  }

  connect() {
    const startValue = this.targetNumberValue / 20;
    const options = {
      startVal: startValue,
      enableScrollSpy: true,
      scrollSpyDelay: 200,
      useGrouping: this.useGroupingValue,
      suffix: this.suffixValue,
      decimalPlaces: this.decimalPlacesValue
    }

    const countUp = new CountUp(this.targetIdValue, this.targetNumberValue, options);
    countUp.start();
  }
}
